module.exports = __webpack_public_path__ + "media/images/watermark-6c74f0392c82200e2ae8820c9ee75189.png";